import { AUTH_SSO_OPENIDC, AUTH_SSO_SAML } from 'business/constants';
import { GenderType, TEAM_MANTY_EMAILS, UserT } from 'business/definitions';

export const sortUserListByEmail = (users: UserT[]): UserT[] =>
    users.sort((u1, u2) => (u1.email > u2.email ? 1 : -1));

export const isUserTeamManty = (email: string): boolean =>
    TEAM_MANTY_EMAILS.includes(email);

/**
 * Convert from various localized gender format to
 * the internal Manty format.
 * @param gender - A gender string.
 * @return 'M' for man 'F' for women, 'M' by default.
 */
export const convertGender = (gender: string): GenderType => {
    switch (gender) {
        case 'F':
        case 'Mme':
            return 'F';
        // Could just fall into the default case directly
        // but I prefer to keep the expected case just
        // for the documentation and in case we want to
        // have a neutral gender one day.
        case 'H':
        case 'M':
        case 'Mr':
        default:
            return 'M';
    }
};

/**
 * Formatter to display a user.
 * It returns the email if both first and last names don't exist, else their concatenation.
 */
export const getUserLabel = (user: UserT) => {
    if (!user.firstname && !user.lastname) return user.email;
    if (user.firstname && user.lastname)
        return `${user.firstname} ${user.lastname}`;
    return (user.firstname ?? '') + (user.lastname ?? '');
};

/**
 * Return true if an user auth_methods contains a SSO method.
 */
export const hasSso = (auth_methods: string[]): boolean => {
    return auth_methods.some(
        (e) => e === AUTH_SSO_OPENIDC || e === AUTH_SSO_SAML,
    );
};
